import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.is-extensible";
import "core-js/modules/es6.object.is-extensible";
import { jsx as ___EmotionJSX } from "@emotion/core";
/** @jsx jsx */

import { jsx } from 'theme-ui';
var styles = {
  iframe: function iframe(showingCode, height) {
    if (height === void 0) {
      height = 'auto';
    }

    return {
      height: height,
      display: 'block',
      minHeight: '100%',
      width: 'calc(100% - 2px)',
      border: function border(t) {
        return "1px solid " + t.colors.playground.border;
      },
      borderRadius: showingCode ? '4px 4px 0 0' : '4px'
    };
  }
};
export var LivePreviewWrapper = function LivePreviewWrapper(_ref) {
  var children = _ref.children,
      showingCode = _ref.showingCode;
  return jsx("div", {
    sx: styles.iframe(showingCode)
  }, children);
};

if (typeof LivePreviewWrapper !== 'undefined' && LivePreviewWrapper && LivePreviewWrapper === Object(LivePreviewWrapper) && Object.isExtensible(LivePreviewWrapper)) {
  Object.defineProperty(LivePreviewWrapper, '__filemeta', {
    configurable: true,
    value: {
      name: "LivePreviewWrapper",
      filename: "node_modules/gatsby-theme-docz/src/components/Playground/LivePreviewWrapper.js"
    }
  });
}